import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction, Value } from "@mcurros2/microm";
import { ClientesServicios } from "../ClientesServicios/ClientesServicios";
import { ClientesTiendasServicios } from "../ClientesTiendasServicios/ClientesTiendasServicios";


export const ACTQuitarServicios: EntityClientAction = {
    name: 'ACTQuitarServicios',
    label: 'Quitar servicios',
    title: <Text fw={700}>Quitar servicios</Text>,
    refreshOnClose: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as ClientesTiendasServicios;
        const servicios = new ClientesServicios(entity.API.client);
        servicios.parentKeys = parent.parentKeys;

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Quitar servicios</Text>,
                    size: 'md'
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={servicios}
                    viewName={servicios.def.views.clse_brwStandard.name}
                    title="Quitar servicios seleccionados"
                    confirmContent="¿Está seguro de que desea Quitar los servicios seleccionados a las tiendas seleccionadas?"
                    onActionFinished={async () => { if (onClose) await onClose(); }}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            if (selectedKeys && selectedKeys.length > 0) {
                                const clientes_tiendas_servicios = new ClientesTiendasServicios(entity.API.client, entity.parentKeys);

                                const parentKeys: Record<string, Value> = {};
                                parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name] = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name];

                                for (const key of selectedKeys) {
                                    parentKeys[clientes_tiendas_servicios.def.columns.c_tienda_id.name] = key[clientes_tiendas_servicios.def.columns.c_tienda_id.name];

                                    await clientes_tiendas_servicios.API.deleteData(keys, abortSignal, parentKeys);
                                }
                            }
                            return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                        }
                    }
                />

            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);

    }

}

